import { clsx } from 'clsx'
import { useId, type ReactNode } from 'react'

/** An on/off setting with its label; the whole row is clickable. */
export function Switch({
  checked,
  onChange,
  label,
  hint,
  disabled,
}: {
  checked: boolean
  onChange: (checked: boolean) => void
  label: ReactNode
  hint?: ReactNode
  disabled?: boolean
}) {
  const id = useId()
  return (
    <div className={clsx('flex items-start justify-between gap-4', disabled && 'opacity-60')}>
      <label htmlFor={id} className={clsx('min-w-0 text-sm', disabled ? 'cursor-not-allowed' : 'cursor-pointer')}>
        <span className="font-medium">{label}</span>
        {hint && <span className="mt-0.5 block text-[13px] text-faint">{hint}</span>}
      </label>
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={clsx(
          'relative mt-0.5 inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors disabled:cursor-not-allowed',
          checked ? 'bg-accent' : 'bg-surface-3',
        )}
      >
        <span className={clsx('inline-block size-4 rounded-full bg-white shadow transition-transform', checked ? 'translate-x-[18px]' : 'translate-x-0.5')} />
      </button>
    </div>
  )
}
